import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { LazyMarkdown } from '@sorare/core/src/atoms/markdown/LazyMarkdown';
import { ContentContainer } from '@sorare/core/src/components/landing/LandingMultiSport/ui';

const StyledContainer = styled(ContentContainer)`
  & p {
    margin-bottom: 1em;
    margin-top: 0.5em;
    line-height: 1.5em;
    color: var(--c-nd-400-opaque);
  }
  & ul li {
    list-style: disc;
    color: var(--c-nd-400-opaque);
  }
`;

const messages = defineMessages({
  content: {
    id: 'Football.Landing.FAQ.content',
    defaultMessage: `

## What is Sorare?
Sorare is the fantasy football game where you collect officially licensed digital player cards, build your dream team, and compete for rewards like cash, tickets, and VIP experiences.


## What is fantasy football?
Fantasy football turns you into a manager — your players score points based on real match performances. It's a test of your football knowledge, strategic planning, tactical thinking. When they shine on the field, you earn rewards!

## Why choose Sorare?
Sorare brings together a community of over 3 million users through exclusive partnerships with all 30 NBA clubs for the ultimate fantasy basketball experience. Sorare also covers the world's leading sports leagues — including all the clubs of the MLB and football giants like the [Premier League](https://sorare.com/football/premier-league), [Bundesliga](https://sorare.com/football/bundesliga), [LALIGA](https://sorare.com/football/laliga), and [Ligue 1](https://sorare.com/football/ligue-1).`,
  },
});

export const FAQ = () => {
  const { formatMessage } = useIntl();
  const content = formatMessage(messages.content);

  return (
    <StyledContainer>
      <LazyMarkdown data={content} />
    </StyledContainer>
  );
};
